module.exports = __webpack_public_path__ + "static/media/witer_q.73fe0ba2.png";